import React from 'react';
import s from './s.module.less';

const ChatLoading = () => {
    return (
        <div className={s.wrap}>
            <span className={s.item1} />
            <span className={s.item2} />
            <span className={s.item3} />
        </div>
    );
};

export default ChatLoading;
